function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCycle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      fill: "rgb(2.352941%,19.607843%,3.921569%)",
      fillOpacity: 1,
      strokeWidth: 0.75,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(2.352941%,19.607843%,3.921569%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.850391 7.5 C 1.850391 4.662891 4.058203 1.850391 7.5 1.850391 C 10.277344 1.850391 11.651953 3.907031 12.235547 5.000391 L 10.498828 5.000391 C 10.224609 5.000391 9.999609 5.225391 9.999609 5.499609 C 9.999609 5.777344 10.224609 5.998828 10.498828 5.998828 L 13.501172 5.998828 C 13.775391 5.998828 14.000391 5.777344 14.000391 5.499609 L 14.000391 2.500781 C 14.000391 2.223047 13.775391 2.001562 13.501172 2.001562 C 13.223437 2.001562 12.998437 2.223047 12.998437 2.500781 L 12.998437 4.314844 C 12.295312 3.070312 10.667578 0.848437 7.5 0.848437 C 3.435937 0.848437 0.848437 4.184766 0.848437 7.5 C 0.848437 10.815234 3.435937 14.151562 7.5 14.151562 C 9.444141 14.151562 11.061328 13.381641 12.214453 12.207422 C 12.833203 11.581641 13.314844 10.839844 13.641797 10.041797 C 13.747266 9.785156 13.624219 9.493359 13.371094 9.387891 C 13.114453 9.282422 12.822656 9.405469 12.717187 9.658594 C 12.435937 10.344141 12.024609 10.973437 11.500781 11.507812 C 10.530469 12.495703 9.166406 13.149609 7.5 13.149609 C 4.058203 13.149609 1.850391 10.337109 1.850391 7.5 Z M 1.850391 7.5 ",
    transform: "matrix(1.111111,0,0,1.111111,1.666667,1.666667)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCycle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cycle.741dddeb.svg";
export { ForwardRef as ReactComponent };